import React , { useState, useEffect } from 'react';
import { EXCHANGE_GURU_DAN } from '../../config/media';
import { CheckOutlined } from '@ant-design/icons';
import { Button } from 'antd';

const ExchangeGuru = ({handleSuccess}) => {
const [setup,setSetup]=useState(false);
const [is_white,setIsWhite]=useState(false);

useEffect(()=>{
    setTimeout(() => {
        setSetup(true)
    }, 1000)
    setTimeout(() => {
        setIsWhite(true)
    }, 2000)
},[])

	return (
		<div className='animation-container-wrapper'>
			<div
				className={!setup ? 'animation-container-1' : 'animation-container'}
			>
				<div className="image-container">
					<img
						src={EXCHANGE_GURU_DAN}
						alt="sample"
						className="image-content"
					/>
					{setup && <div className="text-content">Exchange Guru Dan</div>}
				</div>
				<div style={{ marginLeft: (setup && window.innerWidth > 540) ? '25px' : '' }}>
					{setup && (
						<div
							className={
								is_white
									? 'message-container c-box'
									: 'message-container'
							}
						>
							<div className="pointer"></div>
							<div
								className="comment-box"
								style={{
									color: is_white
										? '#fff'
										: '#A8A8B1' /* padding: is_white ? '15px 30px':'25px 30px' */,
								}}
							>
								<div className="confirmation-container">
                                    <span className='pr-1' role="img" aria-label="emoji name">
										🙌
									</span>
									<div>
										<div>
											<p> Alright! Your initial setup is done.</p>
											<p style={{ fontWeight: 'bold' }}>
												Now, to go live, here's what you need to do:
											</p>
										</div>
										<div className="steps-wrapper">
											<p>1. Verify your identity</p>
											<p>2. Review and accept the user agreement</p>
											<p>3. Connect your domain and setup hosting</p>
										</div>
										<span>
											If you have any questions or issues just
											contact support.
										</span>
									</div>
								</div>
							</div>
						</div>
					)}
					<div
						className={setup ? 'button-container' : 'button-container-1'}
					>
						<div className="button-pointer"></div>
						<Button
							block
							type="primary"
							onClick={setup ? (e) => handleSuccess(e) : () => {}}
						>
							<CheckOutlined />
							OK!
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ExchangeGuru;